// extracted by mini-css-extract-plugin
export default {"cv":"CV_cv__oYl9K"};